import { render } from "./Dock.vue?vue&type=template&id=0ce46dd6&scoped=true&ts=true"
import script from "./Dock.vue?vue&type=script&lang=ts"
export * from "./Dock.vue?vue&type=script&lang=ts"

import "./Dock.vue?vue&type=style&index=0&id=0ce46dd6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce46dd6"]])

export default __exports__